/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResultRow } from './ResultRow';
import {
    ResultRowFromJSON,
    ResultRowFromJSONTyped,
    ResultRowToJSON,
    ResultRowToJSONTyped,
} from './ResultRow';
import type { ScoringMode } from './ScoringMode';
import {
    ScoringModeFromJSON,
    ScoringModeFromJSONTyped,
    ScoringModeToJSON,
    ScoringModeToJSONTyped,
} from './ScoringMode';
import type { CompetitionProblemRead } from './CompetitionProblemRead';
import {
    CompetitionProblemReadFromJSON,
    CompetitionProblemReadFromJSONTyped,
    CompetitionProblemReadToJSON,
    CompetitionProblemReadToJSONTyped,
} from './CompetitionProblemRead';
import type { FeedbackLevel } from './FeedbackLevel';
import {
    FeedbackLevelFromJSON,
    FeedbackLevelFromJSONTyped,
    FeedbackLevelToJSON,
    FeedbackLevelToJSONTyped,
} from './FeedbackLevel';

/**
 * Results of an event, filtered to the rows the caller may see.
 * @export
 * @interface EventResults
 */
export interface EventResults {
    /**
     * 
     * @type {string}
     * @memberof EventResults
     */
    event_id: string;
    /**
     * 
     * @type {ScoringMode}
     * @memberof EventResults
     */
    scoring_mode: ScoringMode;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof EventResults
     */
    feedback: FeedbackLevel;
    /**
     * 
     * @type {Array<CompetitionProblemRead>}
     * @memberof EventResults
     */
    problems: Array<CompetitionProblemRead>;
    /**
     * 
     * @type {Array<ResultRow>}
     * @memberof EventResults
     */
    rows: Array<ResultRow>;
}



/**
 * Check if a given object implements the EventResults interface.
 */
export function instanceOfEventResults(value: object): value is EventResults {
    if (!('event_id' in value) || value['event_id'] === undefined) return false;
    if (!('scoring_mode' in value) || value['scoring_mode'] === undefined) return false;
    if (!('feedback' in value) || value['feedback'] === undefined) return false;
    if (!('problems' in value) || value['problems'] === undefined) return false;
    if (!('rows' in value) || value['rows'] === undefined) return false;
    return true;
}

export function EventResultsFromJSON(json: any): EventResults {
    return EventResultsFromJSONTyped(json, false);
}

export function EventResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventResults {
    if (json == null) {
        return json;
    }
    return {
        
        'event_id': json['event_id'],
        'scoring_mode': ScoringModeFromJSON(json['scoring_mode']),
        'feedback': FeedbackLevelFromJSON(json['feedback']),
        'problems': ((json['problems'] as Array<any>).map(CompetitionProblemReadFromJSON)),
        'rows': ((json['rows'] as Array<any>).map(ResultRowFromJSON)),
    };
}

export function EventResultsToJSON(json: any): EventResults {
    return EventResultsToJSONTyped(json, false);
}

export function EventResultsToJSONTyped(value?: EventResults | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_id': value['event_id'],
        'scoring_mode': ScoringModeToJSON(value['scoring_mode']),
        'feedback': FeedbackLevelToJSON(value['feedback']),
        'problems': ((value['problems'] as Array<any>).map(CompetitionProblemReadToJSON)),
        'rows': ((value['rows'] as Array<any>).map(ResultRowToJSON)),
    };
}

